<i18n src="@/common/i18n/i18n-locales.json"></i18n>
<i18n>
{
  "en": {
    "orderDetails": "Order Details",
    "updateOrder": "Update Order",
    "placeOrder": "Place Order",
    "paymentMethod": "Payment Method",
    "discount": "Discount {discount}% off",
    "phoneNumber": "Phone Number",
    "taxId": "Tax ID:",
    "serviceCharge": "+{serviceCharge}% service charge",
    "totalPrice": "Total: $ {price}"
  },
  "zh-tw": {
    "orderDetails": "餐點明細",
    "updateOrder": "更新訂單",
    "placeOrder": "送出訂單",
    "paymentMethod": "付款方式",
    "discount": "優惠折扣 {discount}%",
    "phoneNumber": "手機號碼",
    "taxId": "統一編號:",
    "serviceCharge": "+{serviceCharge}% 服務費",
    "totalPrice": "總計 {price} 元"
  }
}
</i18n>

<template>
  <f7-page>
    <f7-navbar back-link="Back">
      <f7-nav-title>{{ $t(`pageTitle.myOrder`) }}</f7-nav-title>
      <f7-nav-right>
        <f7-link
          @click="confirmDelete()">
          <font-awesome-icon icon="trash" />
        </f7-link>
      </f7-nav-right>
    </f7-navbar>
    <order-settings />
    <hr class="hr-text" :data-content="$t(`orderDetails`)">
    <cart />
    <br><br>
    <f7-button
      fill
      :style="{ color: allItemObjs.length !== 0 && errorList.length === 0 ? 'white' : 'gray', 'background-color': publicId ? '#FF0000' : '#4CAF50' }"
      style="position: fixed; left: 0px; bottom: 0px; width: 100%; height: 45px; line-height: 45px; z-index: 15; display: flex; flex-direction: row; justify-content: center; gn-items: center;"
      @click="checkOrder()">
      <span v-if="serviceCharge !== 0" style="position: absolute; top: 0; left: 0; margin-left: 15px;">{{ $t(`serviceCharge`, { serviceCharge }) }}</span>
      <span v-if="publicId">{{ $t(`updateOrder`) }}</span><span v-else>{{ $t(`placeOrder`) }}</span>
      <span style="position: absolute; top: 0; right: 0; margin-right: 15px;">{{ $t(`totalPrice`, { price: discountTotalPrice }) }}</span>
    </f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import OrderSettings from '../components/OrderSettings'
import Cart from '../components/Cart'
import moment from 'moment'
import { isGuiNumberValid } from 'taiwan-id-validator'
import { storeClient } from '@/service/apiClients'

export default {
  name: 'OrderPage',
  dependencies: [
    'diningPreferenceType',
    'receiptCarrierType',
    'paymentMethodType',
    'orderClient',
    'CartElementBuilder'
  ],
  computed: {
    ...mapState([
      'store',
      'nickname',
      'publicId',
      'taxId',
      'diningPreference',
      'paymentMethod',
      'tableNumber',
      'phoneNumber',
      'pickupTime',
      'receiptCarrier',
      'receiptCarrierId'
    ]),
    ...mapState('itemModule', [ 'cart' ]),
    ...mapGetters([
      'storeId',
      'payFirst',
      'useCashier',
      'useReceipt',
      'serviceCharge',
      'currentMenu',
      'isReceiptCarrierIdValid',
      'isPhoneNumberValid',
      'orderParams'
    ]),
    ...mapGetters('itemModule', ['totalPrice', 'allItemObjs', 'discountTotalPrice']),
    errorList () {
      const errorList = []
      if (this.diningPreference === this.diningPreferenceType.forHere && !this.tableNumber) {
        errorList.push('桌號未填寫')
      }
      if (this.diningPreference === this.diningPreferenceType.preOrder && !this.pickupTime) {
        errorList.push('請選擇預約時間')
      }
      if (this.diningPreference === this.diningPreferenceType.preOrder && !this.phoneNumber) {
        errorList.push('請輸入手機號碼')
      } else if (this.diningPreference === this.diningPreferenceType.preOrder && !this.isPhoneNumberValid) {
        errorList.push('請檢查手機號碼是否為 10 位數字')
      }
      if (!this.paymentMethod) {
        errorList.push('請選擇付款方式')
      }
      if (this.useReceipt && this.useCashier && !this.receiptCarrier) {
        errorList.push('請選擇發票載具')
      }
      if (
        (
          this.receiptCarrier === this.receiptCarrierType.barcode ||
          this.receiptCarrier === this.receiptCarrierType.cdc ||
          this.receiptCarrier === this.receiptCarrierType.donate
        ) &&
        !this.isReceiptCarrierIdValid
      ) {
        errorList.push('發票載具 ID 或捐贈愛心碼格式錯誤')
      }
      if (this.paymentMethod === this.paymentMethodType.easyCard && this.totalPrice > 1000) {
        errorList.push(`悠遊卡單筆消費最高 1000 元`)
      }
      if ((!this.useCashier || this.receiptCarrier === this.receiptCarrierType.paper) && this.taxId.length !== 0 && !isGuiNumberValid(this.taxId, true)) {
        errorList.push(`統一編號: ${this.taxId} 格式驗證錯誤，請重新輸入統一編號`)
      }
      if (this.diningPreference === this.diningPreferenceType.preOrder &&
        moment(this.pickupTime).diff(moment(new Date()), 'minutes') < this.availableTime - 5) {
        errorList.push(`預約外帶請在 ${this.availableTime - 5} 分鐘之前預約`)
      }

      const itemErrorString = this.allItemObjs
        .map(o => this.CartElementBuilder.buildItem(o, this.currentMenu))
        .reduce((r, i) =>
          i.inValidQuestions.length === 0
            ? r
            : `${r}[${i.title}]:<br>&nbsp;&nbsp;&nbsp;&nbsp;${i.inValidQuestions.join('<br>&nbsp;&nbsp;&nbsp;&nbsp;')}`, '')

      if (itemErrorString) {
        errorList.push(itemErrorString)
      }

      return errorList
    }
  },
  methods: {
    async checkOrder () {
      if (this.allItemObjs.length !== 0) {
        const errorList = this.errorList

        if (errorList.length !== 0) {
          this.$f7.dialog.alert('*' + errorList.join('<br>*'), '請更正訂單')
        } else {
          if (!this.payFirst) {
            this.$f7.dialog.confirm('送出後即無法修改，是否送出訂單?', '確認送出', () => {
              this.sendOrder()
            })
          } else {
            this.sendOrder()
          }
        }
      }
    },
    async sendOrder () {
      this.$f7.dialog.progress('正在傳送訂單，請稍待...')
      const timoutId = setTimeout(() => {
        this.$f7.dialog.close()
        this.$f7.dialog.alert('訂單傳送失敗，請重新整理或稍後再試', '錯誤')
      }, 60000)
      try {
        const { data: result } = this.publicId
          ? await this.orderClient.updateOrder(this.cart, this.orderParams, this.currentMenu, this.storeId)
          : await this.orderClient.sendNewOrder(this.cart, this.orderParams, this.currentMenu, this.storeId)
        this.setNickname(result.nickname)
        this.setOrderPublicId(result.publicId)
        if (this.payFirst && this.paymentMethod === this.paymentMethodType.linePayOnline) {
          const result = await storeClient.get(`/stores/${this.storeId}/orders/${this.publicId}/payment/${this.paymentMethod}/info`)
          window.replaceLocation(result.data.paymentUrl.web)
        } else {
          this.$f7.views.main.router.navigate(`/stores/${this.storeId}/payment`)
        }
      } catch (e) {
        console.error(e)
        this.$f7.dialog.alert('操作失敗，請重新點餐', '無法更新訂單', () => {
          this.resetBucket({ itemBucket: 'cart' })
          this.resetOrderParams()
          this.$f7router.back()
        })
      } finally {
        clearTimeout(timoutId)
        this.$f7.dialog.close()
      }
    },
    confirmDelete () {
      this.$f7.dialog.confirm('清除已放入購物車的所有餐點?', '清除購物車', () => {
        this.resetBucket({ itemBucket: 'cart' })
        this.$f7router.back()
      })
    },
    ...mapActions('itemModule', ['resetBucket']),
    ...mapActions([
      'resetOrderParams',
      'setNickname',
      'setOrderPublicId',
      'setAgentId',
      'setPaymentMethod'
    ])
  },
  components: {
    OrderSettings,
    Cart
  }
}
</script>

<style lang="scss" scoped>
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .9;
  margin: 20px 0px;
  &:before {
    content: '';
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    // #818078
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 .5em;
    line-height: 1.5em;
    // this is really the only tricky part, you need to specify the background color of the container element...
    color: #818078;
    background-color: #FFFFFF;
  }
}
</style>
